import { useNavigate } from 'react-router-dom';

import styles from './styles.module.scss';

const ScoringValue = ({ locationId, imageUrlDay, imageUrlNight, description, value, selectedDate, onValueEnter, onValueLeave }) => {
  const navigate = useNavigate();

  const goToTimeline = (sensorId) => {
    goToTimeline({id: sensorId, date: selectedDate, navigate});
  };

  const showPopup = ({ e, imageDay, imageNight, text }) => {
    const { top, bottom, left } = e.target.getBoundingClientRect();
    onValueEnter({left, top, bottom, imageDay, imageNight, text});
  };

  return (
    <>
      <button
        className={styles.scoringValue}
        onClick={() => goToTimeline(locationId)}
        onMouseEnter={(e) =>
          showPopup({
            e,
            imageDay: imageUrlDay,
            imageNight: imageUrlNight,
            text: description,
          })
        }
        onMouseLeave={onValueLeave}
        // style={{ right: `${100 - value}%` }}
      >
        {value}
      </button>
    </>
  );
};

export default ScoringValue;
